<template>
  <div class="h-100">
    <div class="loader-cont" v-dxloader="isLoader"></div>
    <div class="row h-100" v-show="!isLoader">
      <div class="content-wrapper-before gradient-45deg-indigo-purple"></div>
      <div class="breadcrumbs-dark pb-0 pt-4" id="breadcrumbs-wrapper">
        <div class="container">
          <div class="row">
            <div class="col s10 m6 l6 alignLeft">
              <h5 class="card-title alignLeft white-text">Add Services</h5>
            </div>
          </div>
        </div>
      </div>
      <div class="col s12" style="height:calc(100% - 64px)">
        <div class="container h-100">
          <div class="section h-100">
            <div class="row h-100">
              <div class="col s12 m12 l12 h-100">
                <div id="responsive-table" class="card card card-default scrollspy full-ht h-100">
                  <div class="card-content h-100">
                    <div class="row m-0 h-100">
                      <div class="col s12 h-100">
                        <form class="row m-0 form">
                          <div class="col s12">
                            <div class="row">
                              <div class="col s12">
                                <div class="input-field col s6">
                                  <select
                                    id="category"
                                    name="category"
                                    v-model="serviceDetail.category.id"
                                  >
                                    <option value disabled>Choose Service Category</option>
                                    <option
                                      v-for="(catitem) in categoryList"
                                      :key="catitem.name"
                                      :value="catitem.id"
                                    >{{catitem.name}}</option>
                                  </select>
                                  <label class="fs-8">Service Category</label>
                                </div>
                                <div class="input-field col s6">
                                  <input
                                    id="name"
                                    v-model="serviceDetail.name"
                                    name="name"
                                    type="text"
                                  />
                                  <label for="name" class>Service Name</label>
                                </div>
                                <!-- <div class="input-field col s4">
                                    <input maxlength="50" v-model="serviceDetail.duration" name="duration" id="duration" type="text">
                                    <label for="duration" class>Duration</label>
                                </div>-->
                                <!-- <div class="input-field col s12" :class="{'edit' : serviceId}">
                                    <textarea id="description" v-model="serviceDetail.description" name="description" class="materialize-textarea"></textarea>
                                    <label for="description">Description</label>
                                </div>-->
                                <div class="input-field col s12">
                                  <label for="description" class="fs-8 description">Description</label>
                                  <editor
                                    :init="tynyInitObj"
                                    api-key="0v0a5m4g0aiec6pr65g9jrr231ojdi4wl36sms4rnczgcof6"
                                    v-model="serviceDetail.description"
                                  ></editor>
                                </div>
                              </div>
                            </div>
                            <div class="bb-line"></div>
                            <div class="row">
                              <div class="col s12">
                                <div class="col s12">
                                  <h5 class="alignLeft heading-small">Work Orders</h5>
                                </div>
                                <div class="col s12">
                                  <div
                                    class="row workorder"
                                    v-for="(item,index) in workOrders"
                                    :key="item.idx"
                                  >
                                    <div class="col s7">
                                      <div class="input-field">
                                        <input
                                          v-model="item.text"
                                          :id="'order' + item.idx"
                                          type="text"
                                          data-length="100"
                                        />
                                        <label :for="'order' + item.idx" class>Step {{index + 1}}</label>
                                      </div>
                                    </div>
                                    <div class="col s3" v-if="workOrders.length > 1">
                                      <div class="action-btns">
                                        <a @click="removeOrder(item)" class="pointer delbtn">
                                          <img src="/assets/images/remove.svg" alt />
                                        </a>
                                      </div>
                                    </div>
                                    <div
                                      class="col s12"
                                      v-if="index == workOrders.length - 1 && workOrders.length <= 10"
                                    >
                                      <div class="action-btns ml-0 mt-0">
                                        <a class="pointer" @click="addMoreOrder(item)">
                                          <span class="add-new-btn">
                                            <i class="material-icons">add</i>
                                          </span>
                                          Add another
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="bb-line"></div>
                            <div class="col s12">
                              <h5 class="alignLeft mtrq heading-small">Service Requirements</h5>
                            </div>
                            <div
                              class="row requirement"
                              v-for="(require,rIndex) in requirementList"
                              :key="require.idx"
                            >
                              <h6 class="alignLeft reqTitle">Requirement {{rIndex + 1}}</h6>
                              <div class="col s8">
                                <div class="input-field">
                                  <input
                                    v-model="require.label"
                                    :id="'label-' + require.idx"
                                    type="text"
                                  />
                                  <label
                                    :for="'label-' + require.idx"
                                    :class="{'active' : require.label !=''}"
                                  >What is the Requirement?</label>
                                </div>
                                <div
                                  class="row mar-req"
                                  v-for="(opts,optIndex) in require.options"
                                  :key="opts.idx"
                                >
                                  <div class="col s4">
                                    <div class="input-field">
                                      <input
                                        v-model="opts.value"
                                        :id="'label-req-' + (opts.idx + require.idx)"
                                        type="text"
                                      />
                                      <label
                                        :for="'label-req-' + (opts.idx + require.idx)"
                                        :class="{'active' : opts.value !=''}"
                                      >Option</label>
                                    </div>
                                  </div>
                                  <div class="col s4">
                                    <div class="input-field">
                                      <input
                                        v-number-only
                                        maxlength="6"
                                        :id="'label-cost-' + (opts.idx + require.idx)"
                                        v-model="opts.cost"
                                        type="text"
                                      />
                                      <label
                                        :for="'label-cost-' + (opts.idx + require.idx)"
                                        :class="{'active' : opts.cost !=''}"
                                      >Cost</label>
                                    </div>
                                  </div>
                                  <div class="col s4">
                                    <div class="input-field">
                                      <input
                                        maxlength="50"
                                        :id="'label-duration-' + (opts.idx + require.idx)"
                                        v-model="opts.duration"
                                        name="duration"
                                        type="text"
                                      />
                                      <label
                                        :for="'label-duration-' + (opts.idx + require.idx)"
                                        :class="{'active' : opts.cost !=''}"
                                      >Duration</label>
                                    </div>
                                  </div>
                                  <div class="action-btns">
                                    <a
                                      v-if="optIndex == require.options.length - 1"
                                      @click="addMoreRequirementValue(opts,require)"
                                      class="pointer"
                                    >
                                      <span class="add-new-btn">
                                        <i class="material-icons">add</i>
                                      </span>
                                    </a>
                                    <a
                                      v-if="require.options.length>1"
                                      @click="removeRequirementValue(opts,require)"
                                      class="pointer delbtn"
                                    >
                                      <img src="/assets/images/remove.svg" alt />
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <div class="col s3" v-if="requirementList.length > 1">
                                <div class="action-btns">
                                  <a @click="removeRequirement(require)" class="pointer delbtn">
                                    <img src="/assets/images/remove.svg" alt />
                                  </a>
                                </div>
                              </div>
                              <div class="col s12" v-if="rIndex == requirementList.length - 1">
                                <div class="action-btns ml-0 mt-0">
                                  <a class="pointer" @click="addMoreRequirement(require)">
                                    <span class="add-new-btn">
                                      <i class="material-icons">add</i>
                                    </span>
                                    Add requirement
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div class="bb-line"></div>
                            <div class="col s12">
                              <h5 class="alignLeft mtrq heading-small">
                                Service Images
                                <span
                                  class="helpertxt"
                                >(Max 10 images can be uploaded)</span>
                              </h5>
                              <div class="custom-image__upload">
                                <div class="add-document-sec">
                                  <label for="edit-image_upload">
                                    <img src="/assets/images/close.svg" alt />
                                  </label>
                                  <input
                                    type="file"
                                    id="edit-image_upload"
                                    name="edit-image_upload"
                                    accept="image/*"
                                    multiple
                                    @change="onInputChange"
                                  />
                                </div>
                                <div class="image-sortable" v-if="serviceDetail.images.length>0">
                                  <div
                                    class="fm-image-display"
                                    v-for="(img,i) in serviceDetail.images"
                                    :key="i"
                                    :id="i"
                                  >
                                    <span
                                      class="nav-icon material-icons fm-image__close"
                                      @click="onImgRemove(img,'edit')"
                                    >close</span>
                                    <img :src="img.tempUrl" alt="Image" v-if="img.tempUrl" />
                                    <img :src="img.thumbnail" alt="Image" v-if="img.thumbnail" />
                                    <img :src="img.image" alt="Image" v-if="img.image" />
                                    <span class="overlay"></span>
                                  </div>
                                </div>
                              </div>
                              <div class="error-message" v-if="errorMessage">{{errorMessage}}</div>
                            </div>
                          </div>
                          <div class="col s12">
                            <div class="action-btns text-center">
                              <button
                                @click="submit"
                                v-loader-button="isLoading"
                                type="submit"
                                name="action"
                                class="btn round waves-effect waves-light"
                              >{{serviceId ? 'Update' : 'Add'}} Service</button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jquery from "jquery";
import validate from "jquery-validation";
import jqueryui from "jquery-ui";
import Editor from "@tinymce/tinymce-vue";
window.editor = Editor;
export default {
  data() {
    return {
      categoryList: [],
      serviceId: this.$route.params.id,
      workOrders: [
        {
          idx: 1,
          text: ""
        }
      ],
      requirementList: [
        {
          idx: "req1",
          label: "",
          options: [
            {
              idx: "val1",
              value: "",
              cost: "",
              duration: ""
            }
          ]
        }
      ],
      deletedOrder: [],
      serviceDetail: {
        name: "",
        duration: "",
        category: "",
        images: [],
        description: ""
      },
      errorMessage: "",
      Validator: "",
      deletedImages: [],
      isLoading: false,
      isLoader: false,
      tynyInitObj: {
        menubar: false,
        plugins: [
          "advlist autolink lists link image charmap print preview anchor",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste wordcount"
        ],
        toolbar:
          "undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help",
        oninit: this.onInit()
      }
    };
  },
  components: {
    editor: window.editor // <- Important part
  },
  created() {
    setTimeout(() => {
      $(() => {
        this.Validator = $(".form").validate({
          rules: {
            name: {
              required: true
            },
            duration: {
              required: true
            },
            category: {
              required: true
            }
          },
          errorElement: "div",
          errorPlacement: function(error, element) {
            var placement = $(element).data("error");
            if (placement) {
              $(placement).append(error);
            } else {
              error.insertAfter(element);
            }
          },
          submitHandler: e => {
            $("button").attr("disabled", "disabled");
            setTimeout(() => {
              $("button").removeAttr("disabled");
            }, 500);
            setTimeout(() => {
              if (this.serviceId) {
                this.updateService();
              } else {
                this.addService();
              }
            }, 500);
            return false;
          }
        });
        this.initErrorLoopWatch();
      });
    }, 500);
    this.listCategories();
    if (this.serviceId) {
      this.isLoader = true;
      this.retrieveService();
    }
  },
  methods: {
    onInit() {
      // console.log("created");
    },
    initErrorLoopWatch() {
      setTimeout(() => {
        $(".workorder input").on("keyup", e => {
          if (
            $(e.target)
              .next()
              .attr("class") == "error"
          ) {
            $(e.target)
              .next()
              .remove();
          }
        });

        $(".requirement input").on("keyup", e => {
          if (
            $(e.target)
              .next()
              .attr("class") == "error"
          ) {
            $(e.target)
              .next()
              .remove();
          }
        });
      }, 500);
    },
    listCategories() {
      ajax.get(
        Constants.default.APIURL.ServiceCategory,
        res => {
          this.categoryList = res.data;
          if (!this.serviceId) {
            this.serviceDetail.category = this.categoryList[0];
          }
          setTimeout(() => {
            $("select").formSelect();
          }, 200);
        },
        err => {}
      );
    },
    addMoreOrder(item) {
      if (item.text) {
        this.workOrders.push({
          idx: this.workOrders.length + 1,
          text: ""
        });
      } else {
        $("#order" + item.idx).focus();
      }
      this.initErrorLoopWatch();
    },
    removeOrder(item) {
      let index = this.workOrders.findIndex(val => {
        return val.idx == item.idx;
      });
      this.deletedOrder.push(this.workOrders[index].id);
      this.workOrders.splice(index, 1);
      this.workOrders.forEach((val, key) => {
        val.idx = key + 1;
      });
    },
    addMoreRequirement(item) {
      if (item.label) {
        if (
          item.options[item.options.length - 1] &&
          item.options[item.options.length - 1].value &&
          (item.options[item.options.length - 1].cost ||
            item.options[item.options.length - 1].cost == 0) &&
          item.options[item.options.length - 1].duration
        ) {
          this.requirementList.push({
            idx: "req" + (this.requirementList.length + 1),
            label: "",
            options: [
              {
                idx: "val1",
                value: "",
                cost: "",
                duration: ""
              }
            ]
          });
        } else {
          if (!item.options[item.options.length - 1].value) {
            let idx =
              "#label-req-val" + JSON.stringify(item.options.length) + item.idx;
            $(idx).focus();
          } else if (
            !item.options[item.options.length - 1].cost ||
            item.options[item.options.length - 1].cost == 0
          ) {
            let idx =
              "#label-cost-val" +
              JSON.stringify(item.options.length) +
              item.idx;
            $(idx).focus();
          } else if (!item.options[item.options.length - 1].duration) {
            let idx =
              "#label-duration-val" +
              JSON.stringify(item.options.length) +
              item.idx;
            $(idx).focus();
          }
        }
      } else {
        $("#label-" + item.idx).focus();
      }
      this.initErrorLoopWatch();
    },
    removeRequirement(item) {
      let index = this.requirementList.findIndex(val => {
        return val.idx == item.idx;
      });
      this.requirementList.splice(index, 1);
      this.requirementList.forEach((val, key) => {
        val.idx = "req" + (key + 1);
      });
    },
    addMoreRequirementValue(item, require) {
      let list = require.options;
      if (require.label) {
        if (item.value && (item.cost || item.cost == 0) && item.duration) {
          list.push({
            idx: "val" + (list.length + 1),
            value: "",
            cost: "",
            duration: ""
          });
        } else {
          if (!list[list.length - 1].value) {
            let idx =
              "#label-req-val" + JSON.stringify(list.length) + require.idx;
            $(idx).focus();
          } else if (!list[list.length - 1].cost) {
            let idx =
              "#label-cost-val" + JSON.stringify(list.length) + require.idx;
            $(idx).focus();
          } else if (!list[list.length - 1].duration) {
            let idx =
              "#label-duration-val" + JSON.stringify(list.length) + require.idx;
            $(idx).focus();
          }
        }
      } else {
        $("#label-" + require.idx).focus();
      }
      this.initErrorLoopWatch();
    },
    removeRequirementValue(item, require) {
      let list = require.options;
      let index = list.findIndex(val => {
        return val.idx == item.idx;
      });
      list.splice(index, 1);
      list.forEach((val, key) => {
        val.idx = "val" + (key + 1);
      });
    },
    onInputChange(e) {
      let images = e.target.files;
      this.errorMessage = "";
      let fileNames = this.serviceDetail.images.map(a => a.name);
      if (images.length <= 10 && this.serviceDetail.images.length <= 10) {
        Array.from(images).forEach((file, i) => {
          if (i == images.length - 1) {
            setTimeout(() => {
              setTimeout(() => {
                $(".image-sortable").sortable();
              }, 0);
            }, 200);
          }
          file["tempUrl"] = URL.createObjectURL(file);

          if (fileNames.length == 0) {
            this.serviceDetail.images.push(file);
          } else if (fileNames.length > 0 && !fileNames.includes(file.name)) {
            this.serviceDetail.images.push(file);
          }
        });
      } else {
        this.errorMessage = "Please upload maximum of 10 pictures";
      }
      $("#req-image-error").remove();
    },
    onImgRemove(img, type) {
      if (this.serviceId) {
        this.serviceDetail.images.forEach((a, i) => {
          if (a.name != undefined ? a.name == img.name : a.id == img.id) {
            if (a.id != undefined) this.deletedImages.push(a.id);
            this.serviceDetail.images.splice(i, 1);
          }
        });
      } else {
        this.serviceDetail.images.forEach((a, i) => {
          if (a.name == img.name) {
            this.serviceDetail.images.splice(i, 1);
          }
        });
      }

      if (this.serviceDetail.images.length == 0) {
        $("#req-image-error").remove();
        setTimeout(() => {
          $(".custom-image__upload").after(
            `<div id="req-image-error" class="image error">Please add atleast one image.</div>`
          );
        }, 200);
      } else {
        $("#req-image-error").remove();
      }
    },
    addService() {
      let idx = this.workOrders.length - 1;
      let reqidx = this.requirementList.length - 1;
      if (
        !this.workOrders[idx] ||
        (this.workOrders[idx] && !this.workOrders[idx].text)
      ) {
        $(".workorder input")
          .eq(idx)
          .focus();
        if ($("#workorder-error").length == 0) {
          $(".workorder input")
            .eq(idx)
            .after(
              `<div id="workorder-error" class="error">This field is required.</div>`
            );
        }
        return;
      }

      if (
        !this.requirementList[reqidx] ||
        (this.requirementList[reqidx] && !this.requirementList[reqidx].label)
      ) {
        $("#label-req" + (reqidx + 1)).focus();
        setTimeout(() => {
          if ($("#req-error").length == 0) {
            $("#label-req" + (reqidx + 1)).after(
              `<div id="req-error" class="error">This field is required.</div>`
            );
          }
        }, 200);
        return;
      } else {
        let option = this.requirementList[reqidx].options[
          this.requirementList[reqidx].options.length - 1
        ];
        if (!option.value) {
          $(`#label-req-${option.idx}req${reqidx + 1}`).focus();
          setTimeout(() => {
            $(`#label-req-${option.idx}req${reqidx + 1}`).after(
              `<div id="req-val-error" class="error">This field is required.</div>`
            );
          }, 200);
          return;
        }
        if (
          option.cost == null ||
          option.cost == undefined ||
          option.cost === ""
        ) {
          $(`#label-cost-${option.idx}req${reqidx + 1}`).focus();
          setTimeout(() => {
            $(`#label-cost-${option.idx}req${reqidx + 1}`).after(
              `<div id="req-cost-error" class="error">This field is required.</div>`
            );
          }, 200);
          return;
        }
        if (!option.duration) {
          $(`#label-duration-${option.idx}req${reqidx + 1}`).focus();
          setTimeout(() => {
            $(`#label-duration-${option.idx}req${reqidx + 1}`).after(
              `<div id="req-duration-error" class="error">This field is required.</div>`
            );
          }, 200);
          return;
        }
      }

      let reqList = [];
      this.requirementList.forEach((val, key1) => {
        reqList.push(JSON.parse(JSON.stringify(val)));
        reqList[key1].options = [];
        if (val.options.length > 0) {
          val.options.forEach((value, key2) => {
            if (value.value && (value.cost || value.cost == 0)) {
              reqList[key1].options.push(value);
            }
          });
        }
      });

      let query = {
        name: this.serviceDetail.name,
        category: this.serviceDetail.category.id,
        duration: this.serviceDetail.duration,
        description: this.serviceDetail.description,
        images: this.serviceDetail.images,
        requirements: reqList,
        work_order: this.workOrders,
        deleted_work_order: this.deletedOrder
      };

      if (this.serviceDetail.images.length == 0) {
        $("#req-image-error").remove();
        $(".custom-image__upload").after(
          `<div id="req-image-error" class="image error">Please add atleast one image.</div>`
        );
        return;
      }

      if (!tinyMCE.activeEditor.plugins.wordcount.getCount()) {
        $("textarea").focus();
        $("#req-desc-error").remove();
        $(".tox-tinymce").after(
          `<div id="req-desc-error" class="error">This field is required.</div>`
        );
        return;
      }

      let formdata = Vue.jsonToFormdata(query);
      this.isLoading = true;
      window.sendForm
        .post(Constants.default.APIURL.ServiceCreate, formdata)
        .then(res => {
          Vue.toast("Service was added sucessfully.");
          this.$router.push({
            path: "/app/manage-services"
          });
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
        });
    },
    retrieveService() {
      this.isLoader = true;
      ajax.get(
        Constants.default.APIURL.ServiceDetail + this.serviceId,
        res => {
          this.isLoader = false;
          this.serviceDetail = res.data;
          if (this.serviceDetail.work_order.length > 0) {
            this.workOrders = this.serviceDetail.work_order;
            this.workOrders.forEach((val, key) => {
              val.idx = key + 1;
            });
          }
          if (this.serviceDetail.requirements.length > 0) {
            this.requirementList = this.serviceDetail.requirements;
            this.requirementList.forEach((val, key) => {
              val.idx = "req" + (key + 1);
              delete val.is_primary;
              val.options.forEach((opt, keyopt) => {
                delete opt.is_primary;
                opt.idx = "val" + (keyopt + 1);
              });
            });
          }
          setTimeout(() => {
            this.serviceDetail.category.id = this.serviceDetail.category.id;
            M.updateTextFields();
            M.textareaAutoResize($("#description"));
            $(".image-sortable").sortable();
          }, 200);
        },
        err => {
          this.isLoader = false;
        }
      );
    },
    updateService() {
      let idx = this.workOrders.length - 1;
      let reqidx = this.requirementList.length - 1;
      if (this.serviceDetail.images.length == 0) {
        $("#req-image-error").remove();
        $(".custom-image__upload").after(
          `<div id="req-image-error" class="image error">Please add atleast one image.</div>`
        );
      }
      if (!this.serviceDetail.description) {
        $("textarea").focus();
        return;
      }

      let order = $(".image-sortable").sortable("toArray"),
        new_order = [],
        images = [];
      if (this.serviceId) {
        if (order.length > 0) {
          order.forEach((o, i) => {
            if (this.serviceDetail.images[o].id == undefined) {
              images.push(this.serviceDetail.images[o]);
              new_order.push({
                order: i
              });
            } else {
              new_order.push({
                id: this.serviceDetail.images[o].id,
                order: i
              });
            }
          });
        }
      }

      if (
        !this.workOrders[idx] ||
        (this.workOrders[idx] && !this.workOrders[idx].text)
      ) {
        $(".workorder input")
          .eq(idx)
          .focus();
        if ($("#workorder-error").length == 0) {
          setTimeout(() => {
            $(".workorder input")
              .eq(idx)
              .after(
                `<div id="workorder-error" class="error">This field is required.</div>`
              );
          }, 200);
        }
        return;
      }

      if (
        !this.requirementList[reqidx] ||
        (this.requirementList[reqidx] && !this.requirementList[reqidx].label)
      ) {
        $("#label-req" + (reqidx + 1)).focus();
        setTimeout(() => {
          if ($("#req-error").length == 0) {
            $("#label-req" + (reqidx + 1)).after(
              `<div id="req-error" class="error">This field is required.</div>`
            );
          }
        }, 200);
        return;
      } else {
        let option = this.requirementList[reqidx].options[
          this.requirementList[reqidx].options.length - 1
        ];
        if (!option.value) {
          $(`#label-req-${option.idx}req${reqidx + 1}`).after(
            `<div id="req-val-error" class="error">This field is required.</div>`
          );
          return;
        }
        if (
          option.cost == null ||
          option.cost == undefined ||
          option.cost === ""
        ) {
          $(`#label-cost-${option.idx}req${reqidx + 1}`).after(
            `<div id="req-cost-error" class="error">This field is required.</div>`
          );
          return;
        }
        if (!option.duration) {
          $(`#label-duration-${option.idx}req${reqidx + 1}`).after(
            `<div id="req-duration-error" class="error">This field is required.</div>`
          );
          return;
        }
      }

      let reqList = [];
      this.requirementList.forEach((val, key1) => {
        reqList.push(JSON.parse(JSON.stringify(val)));
        reqList[key1].options = [];
        if (val.options.length > 0) {
          val.options.forEach((value, key2) => {
            if (value.value && (value.cost || value.cost == 0)) {
              reqList[key1].options.push(value);
            }
          });
        }
      });

      let query = {
        name: this.serviceDetail.name,
        category: this.serviceDetail.category.id,
        duration: this.serviceDetail.duration,
        description: this.serviceDetail.description,
        requirements: reqList,
        work_order: this.workOrders,
        deleted_work_order: this.deletedOrder,
        images_to_delete: this.deletedImages,
        new_order: new_order
      };

      if (images.length > 0) {
        query.images = images;
      }
      if (this.serviceDetail.images.length == 0) return;
      let formdata = Vue.jsonToFormdata(query);
      this.isLoading = true;
      window.sendForm
        .patch(
          Constants.default.APIURL.ServiceUpdate + this.serviceId,
          formdata
        )
        .then(res => {
          this.isLoading = false;
          Vue.toast("Service was updated sucessfully.");
          this.$router.push({ path: "/app/manage-services" });
        })
        .catch(err => {
          this.isLoading = false;
          let errMsg = Vue.errorHandler(err);
          Vue.toast(errMsg,'toast-error');
        });
    },
    submit() {
      let idx = this.workOrders.length - 1;
      let reqidx = this.requirementList.length - 1;
      if (
        !this.workOrders[idx] ||
        (this.workOrders[idx] && !this.workOrders[idx].text)
      ) {
        $(".workorder input")
          .eq(idx)
          .focus();
        if ($("#workorder-error").length == 0) {
          setTimeout(() => {
            $(".workorder input")
              .eq(idx)
              .after(
                `<div id="workorder-error" class="error">This field is required.</div>`
              );
          }, 200);
        }
      }

      if (
        !this.requirementList[reqidx] ||
        (this.requirementList[reqidx] && !this.requirementList[reqidx].label)
      ) {
        $("#label-req" + (reqidx + 1)).focus();
        setTimeout(() => {
          if ($("#req-error").length == 0) {
            $("#label-req" + (reqidx + 1)).after(
              `<div id="req-error" class="error">This field is required.</div>`
            );
          }
          let option = this.requirementList[reqidx].options[
            this.requirementList[reqidx].options.length - 1
          ];
          if (!option.value) {
            $(`#label-req-${option.idx}req${reqidx + 1}`).after(
              `<div id="req-val-error" class="error">This field is required.</div>`
            );
          }
          if (!option.cost) {
            $(`#label-cost-${option.idx}req${reqidx + 1}`).after(
              `<div id="req-cost-error" class="error">This field is required.</div>`
            );
          }
          if (!option.duration) {
            $(`#label-duration-${option.idx}req${reqidx + 1}`).after(
              `<div id="req-duration-error" class="error">This field is required.</div>`
            );
          }
        }, 200);
      }

      if (this.serviceDetail.images.length == 0) {
        $("#req-image-error").remove();
        setTimeout(() => {
          $(".custom-image__upload").after(
            `<div id="req-image-error" class="image error">Please add atleast one image.</div>`
          );
        }, 500);
      }

      if (!tinyMCE.activeEditor.plugins.wordcount.getCount()) {
        $("textarea").focus();
        setTimeout(() => {
          $("#req-desc-error").remove();
          $(".tox-tinymce").after(
            `<div id="req-desc-error" style="margin-top:5px;" class="error">This field is required.</div>`
          );
        }, 200);
        return;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.workorder {
  margin: 0 !important;
  .col {
    padding: 0 !important;
  }
  .action-btns {
    margin-top: 15px;
    margin-bottom: 0px;
    margin-left: 50px;
    text-align: left;
    // .addbtn{
    //   margin-left: 20px;
    // }
  }
}
.requirement {
  margin: 0 !important;
  .action-btns {
    margin-top: 15px;
    margin-bottom: 0px;
    margin-left: 30px;
    text-align: left;
  }
  .delbtn {
    left: 10px;
    top: 35px;
    img {
      width: 21px;
    }
  }
}

.error-message {
  margin-top: 10px;
  text-align: right !important;
}

.helpertxt {
  color: #183247;
  display: inline-block;
  font-size: 12px;
}

.addbtn {
  margin-right: 20px;
}

.mtrq {
  margin: 20px 0;
}

.mar-req {
  margin-left: -15px;
  margin-right: -30px;
  position: relative;
  .action-btns {
    position: absolute;
    margin: 0 0 0 30px;
    .pointer {
      top: 30px;
      position: relative;
      &.delbtn {
        left: 10px;
        top: 35px;
        img {
          width: 21px;
        }
      }
    }
  }
}

// h5 {
//   font-size: 20px !important;
//   font-weight: 600;
// }

.action-btns {
  display: inline-block;
  height: 100%;
  width: 100%;
  margin-top: 15px;
  text-align: right;
}

.reqTitle {
  margin: 0px 15px 15px;
  padding-top: 0px;
  font-size: 14px;
  display: block;
}

.custom-image__upload {
  width: 100%;
  float: left;
  .image-sortable {
    float: left;
    margin-left: 10px;
  }

  .fm-image-display {
    display: inline-block;
    border: 1px solid #ccc;
    margin-right: 10px;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    width: 75px;
    height: 75px;

    &:hover {
      .fm-image__close {
        display: inline;
      }
      .overlay {
        display: block;
      }
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .fm-image__close {
      display: none;
      position: absolute;
      right: 3px;
      top: 4px;
      font-size: 14px;
      font-weight: 600;
      background: #fff;
      color: #000;
      border-radius: 50%;
      z-index: 1;
    }
    .overlay {
      display: none;
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      opacity: 0.4;
      background: #000;
    }
  }
}
.action-btns .btn {
  border-radius: 5px;
  font-weight: 600;
}

.btn-floating {
  color: #212121 !important;
  background: white !important;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}

.btn-floating i {
  color: #212121 !important;
}

li {
  list-style: inherit !important;
}
.bb-line {
  border-bottom: 1px solid #faf8f8;
  margin-bottom: 10px;
}
label.description {
  margin-top: -15px !important;
}
.card-content {
  padding: 32px 24px;
  overflow: auto;
  font-family: SFProText;
  .input-field {
    .fs-8 {
      font-size: 0.8rem;
    }
    input {
      font-size: 14px;
    }
  }
  .heading-small {
    font-size: 16px;
    font-weight: 500;
  }
}
.mce-content-body {
  font-size: 14px;
}

.add-document-sec {
  display: inline-flex;
  width: 75px;
  height: 75px;
  border-radius: 4px;
  background-color: #f3f4f5;
  justify-content: center;
  cursor: pointer;
  float: left;
  align-items: center;

  input {
    visibility: hidden;
    width: 1px;
    height: 1px;
  }

  img {
    transform: rotate(45deg);
  }

  label {
    display: inline-flex;
    width: 75px;
    height: 75px;
    justify-content: center;
    margin-bottom: 0px;
    cursor: pointer;
  }
}
</style>

